import { Body, Controller, Get, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { CollectionsService } from "./collections.service";
import { AdjusmentNoteRequest, CollectionsFilters, CollectionsReq, DdbCollectionsReq, PaymentTypeReq, ReceivablesDetailsReq, ReceivablesSummaryReq } from "@gtpl/shared-models/finance";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";

@ApiTags('/collections')
@Controller('/collections')
 export class CollectionsController{
    constructor(
        private service :CollectionsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){ }

    @Post('/getCollection')
    async getCollection(@Body() req:PaymentTypeReq): Promise<CommonResponse> {
        try {
            return await this.service.getCollection(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }   
    @Post('/generatePayment')
    async generatePayment(@Body() req:CollectionsReq): Promise<CommonResponse> {
        try {
            return await this.service.generatePayment(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    } 
    @Post('/generateDdbPayment')
    async generateDdbPayment(@Body() req:DdbCollectionsReq): Promise<CommonResponse> {
        try {
            return await this.service.generateDdbPayment(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    } 
    @Post('/getBuyers')
    async getBuyers(@Body() req:PaymentTypeReq): Promise<CommonResponse> {
        try {
            return await this.service.getBuyers(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }  
    @Post('/getReceivablesSummaryReport')
    async getReceivablesSummaryReport(@Body() req:ReceivablesSummaryReq): Promise<CommonResponse> {
        try {
            return await this.service.getReceivablesSummaryReport(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    } 
    @Post('/getReceivablesDetailsReport')
    async getReceivablesDetailsReport(@Body() req:ReceivablesDetailsReq): Promise<CommonResponse> {
        try {
            return await this.service.getReceivablesDetailsReport(req);
        }
        catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getExportReceivablesData')
    async getExportReceivablesData(@Body() req:CollectionsFilters): Promise<CommonResponse>{
        try{
            return await this.service.getExportReceivablesData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getDutyDrawBackData')
    async getDutyDrawBackData(@Body() req:CollectionsFilters):Promise<CommonResponse>{
        try{
            return await this.service.getDutyDrawBackData(req);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Get('/getBuyerSDropDown')
    async getBuyerSDropDown():Promise<CommonResponse>{
        try{
            return await this.service.getBuyerSDropDown();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Get('/getInvoiceNumber')
    async getInvoiceNumber():Promise<CommonResponse>{
        try{
            return await this.service.getInvoiceNumber();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

}
